import { render, staticRenderFns } from "./PickListsIcon.vue?vue&type=template&id=72cc7e23&"
import script from "./PickListsIcon.vue?vue&type=script&lang=js&"
export * from "./PickListsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports